<script>
  import CRUD from './CRUD.svelte';
  import { fetchAtributos, saveAtributo, removeAtributo, searchAtributos, subscribeToAtributos, unsubscribeFromAtributos } from '../controllers/atributoController.js';
  import { t } from 'svelte-i18n';

  // Configuración de las columnas para la tabla CRUD
  let atributoColumns = [
    { label: $t('fields.description'), field: 'descrip', type: 'text' },
    { label: $t('fields.dataType'), field: 'tipo_dato', type: 'text' },
    { label: 'Tipo', field: 'tipo', type: 'text' },
    { label: 'Requerido', field: 'requerido', type: 'boolean' },
    { label: 'Items de Lista', field: 'lista_items', type: 'text', condition: 'tipo_dato === "lista"' },
    { label: 'Creado', field: 'created', type: 'date' },
    { label: 'Actualizado', field: 'updated', type: 'date' }
  ];

  // Objeto para un nuevo atributo
  let newAtributo = {
    descrip: '',
    tipo_dato: 'texto',
    requerido: false,
    tipo: 'producto',
    lista_items: ''
  };

  // Configuración de las columnas para el formulario de edición
  let editColumns = [
    { label: $t('fields.description'), key: 'descrip', type: 'text', required: false },
    {
      label: $t('fields.dataType'),
      key: 'tipo_dato',
      type: 'select',
      required: true,
      options: [
        { key: 'texto', value: 'Texto' },
        { key: 'booleano', value: 'Booleano' },
        { key: 'lista', value: 'Lista' },
        { key: 'numerico', value: 'Numérico' },
        { key: 'fecha', value: 'Fecha' },
        { key: 'archivo', value: 'Archivo' }
      ]
    },
    {
      label: 'Tipo',
      key: 'tipo',
      type: 'select',
      required: true,
      options: [
        { key: 'producto', value: 'Producto' },
        { key: 'cotiza', value: 'Cotización' }
      ]
    },
    { label: 'Requerido', key: 'requerido', type: 'boolean', required: false },
    { 
      label: 'Items de Lista (separados por comas)', 
      key: 'lista_items', 
      type: 'text', 
      required: false,
      placeholder: 'Ej: Opción 1, Opción 2, Opción 3',
      condition: 'tipo_dato === "lista"'
    }
  ]; 

</script>

<!-- Componente CRUD para Atributos -->
<CRUD 
  title={$t('entities.atributos')}
  entityName="atributo"
  newEntity={newAtributo}
  columns={atributoColumns}
  fetchEntities={fetchAtributos}
  saveEntity={saveAtributo}
  removeEntity={removeAtributo}
  searchEntities={searchAtributos}
  subscribeToChanges={subscribeToAtributos}
  unsubscribeFromChanges={unsubscribeFromAtributos}
  editColumns={editColumns}
/>
